import React, { useState } from "react";

export default function ContactForm({
  initialData,
  onSave,
  onCancel,
}) {
  const [form, setForm] = useState(
    initialData || {
      name: "",
      designation: "",
      department: "",
      mobile: "",
      email: "",
      is_primary: false,
      is_active: true,
    }
  );

  return (
    <div
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: 8,
        padding: 16,
        background: "#f9fafb",
        marginBottom: 16,
      }}
    >
      <div className="erp-form-grid">
        <div className="erp-field">
          <label>Contact Name *</label>
          <input
            value={form.name}
            onChange={(e) =>
              setForm({ ...form, name: e.target.value })
            }
          />
        </div>

        <div className="erp-field">
          <label>Designation</label>
          <input
            value={form.designation}
            onChange={(e) =>
              setForm({
                ...form,
                designation: e.target.value,
              })
            }
          />
        </div>

        <div className="erp-field">
          <label>Department</label>
          <input
            value={form.department}
            onChange={(e) =>
              setForm({
                ...form,
                department: e.target.value,
              })
            }
          />
        </div>

        <div className="erp-field">
          <label>Mobile</label>
          <input
            value={form.mobile}
            onChange={(e) =>
              setForm({ ...form, mobile: e.target.value })
            }
          />
        </div>

        <div className="erp-field">
          <label>Email</label>
          <input
            value={form.email}
            onChange={(e) =>
              setForm({ ...form, email: e.target.value })
            }
          />
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            marginTop: 24,
          }}
        >
          <input
            type="checkbox"
            checked={form.is_primary}
            onChange={(e) =>
              setForm({
                ...form,
                is_primary: e.target.checked,
              })
            }
          />
          Primary Contact
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            marginTop: 24,
          }}
        >
          <input
            type="checkbox"
            checked={form.is_active}
            onChange={(e) =>
              setForm({
                ...form,
                is_active: e.target.checked,
              })
            }
          />
          Active
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 10,
          marginTop: 16,
        }}
      >
        <button
          className="btn btn-secondary"
          onClick={onCancel}
        >
          Cancel
        </button>

        <button
          className="btn btn-primary"
          onClick={() => onSave(form)}
        >
          Save Contact
        </button>
      </div>
    </div>
  );
}
